module.exports = __webpack_public_path__ + "img/1fie-q-dance.20af0b9d.jpg";